import { TeamState } from './team.js';
import { Configuration } from './configuration.js';
export abstract class BonusPenalty {
    constructor(
        public team: TeamState,
        public valid: boolean,
        public awarded: Date
    ) {
        if (!team) {
            throw new Error('Team is required');
        }
    }
    abstract score(config: Configuration): number;
    abstract equals(other: BonusPenalty): boolean;
}
